// extracted by mini-css-extract-plugin
export default {"statusCellWrapper":"StatusCell_statusCellWrapper__Kec4o","conflictWarningIcon":"StatusCell_conflictWarningIcon__Rbufy"};